export default __webpack_public_path__ + "static/media/bp-settings.dc34c946.png";